import React from 'react';
import { motion } from 'framer-motion';
import Header from '../components/Header';
import ToolSelector from '../components/ToolSelector';
import Workspace from '../components/Workspace';
import PrivacyNotice from '../components/PrivacyNotice';
import FAQSection from '../components/FAQSection';
import DeveloperFooter from '../components/DeveloperFooter';
import Toast from '../components/Toast';

const ConvertMaster = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <motion.div
        className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.2 }}
      >
        <div className="flex flex-col lg:flex-row gap-6">
          {/* 工具選擇器 */}
          <div className="lg:w-1/3">
            <ToolSelector />
          </div>

          {/* 工作區 */}
          <div className="lg:w-2/3">
            <Workspace />
            <PrivacyNotice />
            <FAQSection />
            <DeveloperFooter />
          </div>
        </div>
      </motion.div>
      <Toast />
    </div>
  );
};

export default ConvertMaster;